import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type {
  PostUserExportSettingsRequest,
  PostUserExportSettingsResponse,
} from '@/types/userExportSettingsApiTypes';
import { USER_EXPORT_SETTINGS_QUERY_KEY } from '../../consts/client-detail';

export const useUpdateUserExportSettingsMutation = () => {
  const queryClient = useQueryClient();
  const { doFetch: postExportSettings } = useFetch<PostUserExportSettingsRequest, PostUserExportSettingsResponse>();

  return useMutation({
    mutationFn: (body: PostUserExportSettingsRequest) =>
      postExportSettings('/api/user/export/settings', {
        method: 'POST',
        body,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_EXPORT_SETTINGS_QUERY_KEY] });
    },
  });
};
